import React from 'react';
import classes from '../../asset/css/subscription-detail/product-item.module.css';

export const ProductBlankItem = () => {
  const imageUrl = 'https://cdn.shopify.com/s/files/1/0574/4348/3843/files/skip_rectangle.png?v=1644398180';
  return (
    <li className={classes.product_item}>
      <div className={classes.product_thumbnail_blank}>
        <div
          style={{ 
            backgroundImage: `url('${imageUrl}')`, 
            backgroundPositionX: `center`,
            backgroundColor: `transparent`
          }}
          className={classes.product_thumbnail_img}
        />
      </div>

      <div className={classes.product_info_blank}>
        <div className={classes.product_info_titlePrice_blank}>
          <h4 className={classes.product_info_title_blank}>お届け予定の商品はありません。</h4>
        </div>
      </div>
    </li>
  );
};
